import React from 'react';
import { Box, Flex, Image, Link } from '@chakra-ui/react';

const navItems = [
  {
    link: {
      href: 'mailto:contact@withloma.com?subject=Help With Loma Onboarding',
      label: 'Contact',
    },
  },
];

const Header = () => {
  return (
    <Box as="header" position="relative" zIndex={20}>
      <Box maxW="lg" py={{ base: 4, sm: 8 }} mx="auto">
        <Flex justify="space-between" ml={{ base: 6, sm: 12 }}>
          <Link href="#" display="flex" alignItems="center">
            <Image
              alt="Loma Logo"
              width={92}
              height={22}
              src="https://loma-files.s3.us-west-1.amazonaws.com/loma-logos/Logo-02.png"
            />
          </Link>
          <Flex align="center" gap={4} mr={{ base: 6, sm: 12 }}>
            <Flex as="nav" gap={3}>
              {navItems.map(({ link }, i) => {
                return (
                  <Link
                    key={i}
                    href={link.href}
                    bg="#0F4245"
                    color="white"
                    style={{ borderRadius: '.2rem' }}
                    px={6}
                    py={2}
                    h="36px"
                    fontSize="sm"
                    display="block"
                    _hover={{ textDecoration: 'none' }}
                    rel="noreferrer noopener"
                    target="_blank"
                  >
                    {link.label}
                  </Link>
                );
              })}
            </Flex>
          </Flex>
        </Flex>
      </Box>
    </Box>
  );
};

export default Header;
